import { JurisprudenceMetadata } from '@jusbrasil-web/shared-apollo-client/types'
import { capitalizePhrase } from '@jusbrasil-web/shared-utils-format'
import Head from 'next/head'

import { getMetaTags } from './meta-tags'
import { getStructuredData } from './structured-data'

export interface ThesisHeadResultProps {
  docUrl: string
  title: string
}
export interface ThesisHeadProps {
  canonicalUrl: string
  clusterLabel: string
  items?: JurisprudenceMetadata[]
  chatVersion?: boolean
}

const buildTitle = ({ labelTerm, chatVersion }: { labelTerm: string; chatVersion: boolean }) => {
  if (chatVersion) {
    return `Tese | ${labelTerm.toLowerCase()}`
  }
  return `Tese Jurisprudencial | ${labelTerm}`
}

export function ThesisHead({
  clusterLabel,
  items,
  canonicalUrl,
  chatVersion = false,
}: ThesisHeadProps) {
  const labelTerm = capitalizePhrase({ phrase: clusterLabel })
  const title = buildTitle({ labelTerm, chatVersion })
  const structuredData = getStructuredData({
    title,
    labelTerm,
    canonicalUrl,
    items:
      items?.map((item) => ({
        name:
          item.addons?.plainFacts ??
          'Ainda não há um resumo dos fatos para este caso, mas ele é relevante porque compartilha a mesma linha argumentativa que fundamenta a tese.',
      })) || [],
  })

  const metaTags = getMetaTags({ title, labelTerm })

  return (
    <Head>
      <title>{title}</title>
      <meta name="robots" content="index,follow" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      {metaTags.map((props, idx) => (
        <meta {...props} key={idx} />
      ))}
    </Head>
  )
}
